import React, { useEffect, useRef } from 'react';
import ApexCharts from 'apexcharts';

const MarketAreaChart = ({ monthlyStats = [] }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      // Destroy existing chart if any
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }

      // Extract data from monthlyStats
      const categories = monthlyStats.length > 0
        ? monthlyStats.map(m => m.month)
        : ['Ян', 'Фев', 'Мар', 'Апр', 'Май', 'Юни', 'Юли', 'Авг', 'Сеп', 'Окт', 'Ное', 'Дек'];
      const incomeData = monthlyStats.length > 0
        ? monthlyStats.map(m => m.income)
        : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      const options = {
        chart: {
          height: 200,
          type: 'line',
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 3,
        },
        series: [
          {
            name: 'Приходи',
            color: '#2E37A4',
            data: incomeData,
          },
        ],
        xaxis: {
          categories: categories,
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val.toFixed(0)} EUR`,
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val.toFixed(2)} EUR`,
          },
        },
      };

      chartInstanceRef.current = new ApexCharts(chartRef.current, options);
      chartInstanceRef.current.render();
    }

    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
        chartInstanceRef.current = null;
      }
    };
  }, [monthlyStats]);

  return <div ref={chartRef}></div>;
};

export default MarketAreaChart;
